import { globalState } from '@codeleap/store'
import { getParams } from '@/services/api/appParams'
import type { AppParamKey, AppParams } from '@/types/appParams'

type StoreValue = { params: Partial<AppParams> }

export const state = globalState<StoreValue>({ params: {} })

export async function loadParams() {
  const appParams = await getParams()
  if (!appParams) return
  const params: Partial<AppParams> = {}
  for (const param of appParams) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params[param.key] = param.value as any
  }
  state.set({ params })
}

export function getParam<K extends AppParamKey>(key: K): AppParams[K] | undefined {
  return state.value.params[key]
}
